export const REQUEST_STATISTICS_ASSET = 'statistics/REQUEST_STATISTICS_ASSET' as const;
export const REQUEST_STATISTICS_ASSET_SUCCESS =
  'statistics/REQUEST_STATISTICS_ASSET_SUCCESS' as const;
export const REQUEST_STATISTICS_ASSET_FAILURE =
  'statistics/REQUEST_STATISTICS_ASSET_FAILURE' as const;

export const REQUEST_STATISTICS_PARTIAL = 'statistics/REQUEST_STATISTICS_PARTIAL' as const;
export const REQUEST_STATISTICS_PARTIAL_SUCCESS =
  'statistics/REQUEST_STATISTICS_PARTIAL_SUCCESS' as const;
export const REQUEST_STATISTICS_PARTIAL_FAILURE =
  'statistics/REQUEST_STATISTICS_PARTIAL_FAILURE' as const;

export const REQUEST_STATISTICS_DOWNLOAD = 'statistics/REQUEST_STATISTICS_DOWNLOAD' as const;
export const REQUEST_STATISTICS_DOWNLOAD_SUCCESS =
  'statistics/REQUEST_STATISTICS_DOWNLOAD_SUCCESS' as const;
export const REQUEST_STATISTICS_DOWNLOAD_FAILURE =
  'statistics/REQUEST_STATISTICS_DOWNLOAD_FAILURE' as const;

export const REQUEST_STATISTICS_STREAMING = 'statistics/REQUEST_STATISTICS_STREAMING' as const;
export const REQUEST_STATISTICS_STREAMING_SUCCESS =
  'statistics/REQUEST_STATISTICS_STREAMING_SUCCESS' as const;
export const REQUEST_STATISTICS_STREAMING_FAILURE =
  'statistics/REQUEST_STATISTICS_STREAMING_FAILURE' as const;

export const REQUEST_STATISTICS_LOGIN = 'statistics/REQUEST_STATISTICS_LOGIN' as const;
export const REQUEST_STATISTICS_LOGIN_SUCCESS =
  'statistics/REQUEST_STATISTICS_LOGIN_SUCCESS' as const;
export const REQUEST_STATISTICS_LOGIN_FAILURE =
  'statistics/REQUEST_STATISTICS_LOGIN_FAILURE' as const;

export const REQUEST_STATISTICS_STORAGE = 'statistics/REQUEST_STATISTICS_STORAGE' as const;
export const REQUEST_STATISTICS_STORAGE_SUCCESS =
  'statistics/REQUEST_STATISTICS_STORAGE_SUCCESS' as const;
export const REQUEST_STATISTICS_STORAGE_FAILURE =
  'statistics/REQUEST_STATISTICS_STORAGE_FAILURE' as const;

export const REQUEST_STATISTICS_EXPORT = 'statistics/REQUEST_STATISTICS_EXPORT' as const;
export const REQUEST_STATISTICS_EXPORT_SUCCESS =
  'statistics/REQUEST_STATISTICS_EXPORT_SUCCESS' as const;
export const REQUEST_STATISTICS_EXPORT_FAILURE =
  'statistics/REQUEST_STATISTICS_EXPORT_FAILURE' as const;
